import { render, staticRenderFns } from "./SmallArrow.vue?vue&type=template&id=7f7eea30&"
import script from "./SmallArrow.vue?vue&type=script&lang=js&"
export * from "./SmallArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports